/* Marinelie — THE GUESTLIST: der Fragebogen.
   Fragen mit Antwort-Grid, dazwischen Fakten über das Haus, dann das
   Gate. Scoring clientseitig: vier Achsen, Nearest Neighbor, kein LLM.
   Antworten können Tags sperren (harter Ausschluss im Match).

   Vergabe serverseitig (atomar). Fällt der Endpunkt aus, bleibt der
   Reveal stehen statt einen Platz zu erfinden. */
(function () {
  'use strict';

  var KEY = 'ml_queue';
  var ACHSEN = ['waerme', 'suesse', 'gewicht', 'dunkel'];

  function lesen() {
    try {
      var p = JSON.parse(localStorage.getItem(KEY) || 'null');
      return p && typeof p === 'object' ? p : {};
    } catch (e) { return {}; }
  }

  function schreiben(patch) {
    try {
      var s = lesen();
      Object.keys(patch).forEach(function (k) { s[k] = patch[k]; });
      localStorage.setItem(KEY, JSON.stringify(s));
      return s;
    } catch (e) { return patch; }
  }

  /* "waerme:+20,suesse:-10" -> {waerme: 20, suesse: -10} */
  function achsenLesen(text) {
    var out = {};
    (text || '').split(',').forEach(function (teil) {
      var kv = teil.split(':');
      if (kv.length !== 2) return;
      var k = kv[0].trim();
      var v = parseInt(kv[1], 10);
      if (k && !isNaN(v)) out[k] = v;
    });
    return out;
  }

  function init() {
    var wurzel = document.querySelector('[data-ml-fragebogen]');
    if (!wurzel) return;

    var endpunkt = (wurzel.getAttribute('data-endpunkt') || '/apps/guestlist').replace(/\/$/, '');

    /* Alles, was das Skript selbst schreibt, kommt uebersetzt aus dem
       Markup (locales/de.json bzw. en.default.json). Faellt das Attribut
       aus, bleibt der deutsche Wortlaut als Rueckfall stehen. */
    var TEXT = {
      moment: 'Einen Moment …',
      nochmal: 'Nochmal versuchen',
      ohne_einwilligung: 'Ohne deine Einwilligung können wir dich nicht eintragen.',
      fehler_eintragen: 'Die Eintragung kam gerade nicht durch. Versuch es gleich noch einmal — deine Antworten bleiben stehen.',
      fehler_vergabe: 'Die Vergabe antwortet gerade nicht. Versuch es gleich noch einmal — deine Antworten bleiben stehen.',
      schon_dabei: 'Den hattest du schon. Er bewegt sich, aber er wird nicht neu vergeben.',
      auf_der_liste: 'Du stehst auf der Liste',
      frage: 'Frage ',
      du_wolltest: 'Du wolltest ',
      frische: 'Frische',
      waerme: 'Wärme',
      suesse: 'Süße',
      keine_suesse: 'keine Süße',
      zurueckhaltung: 'Zurückhaltung',
      praesenz: 'Präsenz',
      hell: 'die helle Seite',
      dunkel: 'die dunkle Seite',
      und: ' und ',
      von: ' von '
    };
    try {
      var ausMarkup = JSON.parse(wurzel.getAttribute('data-texte') || '{}');
      Object.keys(ausMarkup).forEach(function (k) {
        if (ausMarkup[k]) TEXT[k] = ausMarkup[k];
      });
    } catch (e) {}

    /* Alle Screens in DOM-Reihenfolge; Fragen und Fakten laufen linear. */
    var alle = Array.prototype.slice.call(wurzel.querySelectorAll('[data-fb-screen]'));
    var lauf = alle.filter(function (el) {
      var t = el.getAttribute('data-fb-screen');
      return t === 'frage' || t === 'mehrfach' || t === 'fakt' || t === 'duft' || t === 'liste';
    });
    var benannt = {};
    alle.forEach(function (el) {
      var t = el.getAttribute('data-fb-screen');
      if (t !== 'frage' && t !== 'mehrfach' && t !== 'fakt' && t !== 'duft' && t !== 'liste') benannt[t] = el;
    });

    /* Feste Hoehe auf der Guestlist-Seite (ml-quiz-fest.css): wie viel
       oberhalb des Quiz steht, haengt an Ankuendigung und Kopf, darum
       gemessen statt geraten. Im Fenster auf anderen Seiten nicht. */
    /* Im Eintragen-Fenster (ml-blur-nav.js) traegt das Scrollfach die
       Klasse ml-gl-seite; dort zaehlt dessen Scrollstand, und das Fenster
       faehrt erst von unten herein, darum nach 500 ms noch einmal messen. */
    function hoeheMessen() {
      var fb = wurzel.querySelector('.ml-fb');
      var fach = wurzel.closest('.ml-sheet__inhalt');
      if (!fb || !(document.body.classList.contains('ml-gl-seite') || fach)) return;
      var oben = fb.getBoundingClientRect().top + (fach ? fach.scrollTop - fach.getBoundingClientRect().top : window.scrollY);
      if (oben > 0) wurzel.style.setProperty('--ml-fb-oben', Math.round(oben) + 'px');
    }
    hoeheMessen();
    setTimeout(hoeheMessen, 500);
    window.addEventListener('load', hoeheMessen);
    window.addEventListener('resize', hoeheMessen);

    /* Anonyme Statistik (Otton 21.10.2026: "fuer ueberblick gesamten
       traffic haben und nicht nur leute, die absenden"). Je Seitenaufruf
       eine Zufalls-ID, nur im Speicher: kein Cookie, kein Storage, neu
       laden heisst neuer Besuch. Keine Mail, kein Name. Die Herkunft
       (utm) kommt mit, damit man Anzeigen gegen den Rest sieht. */
    var BESUCH = (function () {
      var z = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var r = null;
      try { r = window.crypto.getRandomValues(new Uint8Array(16)); } catch (e) {}
      var out = '';
      for (var i = 0; i < 16; i++) out += z.charAt((r ? r[i] : Math.floor(Math.random() * 256)) % 36);
      return out;
    })();
    function melden(art, schrittName, nr, wahl) {
      try {
        var h = herkunftLesen();
        var daten = JSON.stringify({
          b: BESUCH, a: art, s: schrittName, n: nr, w: wahl || undefined,
          q: h.utm_source, k: h.utm_campaign, c: h.utm_content
        });
        var url = endpunkt + '/quiz';
        /* text/plain: kein Preflight, und sendBeacon kommt auch noch beim
           Schliessen des Tabs durch. */
        if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([daten], { type: 'text/plain' }))) return;
        fetch(url, { method: 'POST', body: daten, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      } catch (e) {}
    }
    function screenName(el) {
      return el.getAttribute('data-fb-id') || el.getAttribute('data-fb-screen') || '';
    }

    /* Fragen, deren Antworten nichts erklaeren, springen nach der Wahl von
       selbst weiter. Dort steht kein Weiter-Knopf (Otton 21.10.: "wenn man
       hier auswaehlt braucht es keinen button, weil es geht direkt weiter"). */
    alle.forEach(function (el) {
      if (el.getAttribute('data-fb-screen') !== 'frage' || el.getAttribute('data-fb-tipp') === 'true') return;
      var stumm = Array.prototype.every.call(el.querySelectorAll('[data-fb-wahl]'), function (k) {
        return !['data-fb-story', 'data-fb-sparte', 'data-fb-echo', 'data-fb-vorteil'].some(function (a) {
          return (k.getAttribute(a) || '').trim();
        });
      });
      if (stumm) el.classList.add('ml-fb__screen--auto');
    });

    var katalog = [];
    var achsenDaten = {};
    try {
      var kEl = wurzel.querySelector('[data-fb-katalog]');
      if (kEl) katalog = JSON.parse(kEl.textContent) || [];
    } catch (e) {}

    var achsenUrl = wurzel.getAttribute('data-achsen-url');
    if (achsenUrl) {
      fetch(achsenUrl)
        .then(function (r) { return r.json(); })
        .then(function (d) { achsenDaten = d || {}; })
        .catch(function () {});
    }

    var profil = { waerme: 50, suesse: 50, gewicht: 50, dunkel: 50 };
    var merkmale = {};
    var gesperrt = [];
    var schritt = -1;

    var verlauf = [];

    function zurueckKnopf() {
      var k = wurzel.querySelector('[data-fb-zurueck]');
      if (!k) return;
      var aktiv = wurzel.querySelector('.is-aktiv');
      var typ = aktiv ? aktiv.getAttribute('data-fb-screen') : '';
      k.hidden = !verlauf.length || typ === 'auftakt' || typ === 'nummer' || typ === 'match';
    }

    function zeigen(el, zurueck) {
      var aktuell = wurzel.querySelector('.is-aktiv');
      if (aktuell && aktuell !== el && !zurueck) verlauf.push(aktuell);
      el.__schritt = zurueck ? el.__schritt : schritt;
      alle.forEach(function (s) { s.classList.remove('is-aktiv'); });
      el.classList.add('is-aktiv');
      var li = lauf.indexOf(el);
      var typ0 = el.getAttribute('data-fb-screen');
      var nrMap = { auftakt: 0, stoff: schritt + 1, gate: lauf.length + 1, nummer: lauf.length + 2, match: lauf.length + 3 };
      melden('zeige', screenName(el), li > -1 ? li + 1 : (nrMap[typ0] !== undefined ? nrMap[typ0] : null));
      /* Der Teil steht rechts oben in der Kopfzeile, neben Zurück. */
      var teilSlot = wurzel.querySelector('[data-fb-teil-oben]');
      if (teilSlot) {
        var teilEl = el.querySelector('.ml-fb__teil');
        teilSlot.textContent = teilEl ? teilEl.textContent : '';
      }
      var fokus = el.querySelector('.ml-fb__titel, .ml-fb__frage, .ml-fb__kicker');
      if (fokus) {
        fokus.setAttribute('tabindex', '-1');
        fokus.focus({ preventScroll: true });
      }
      /* Nur hochscrollen, wenn der Kopf des Fragebogens aus dem Bild
         ist. Steht er schon oben, ruckte das weiche Scrollen bei jedem
         Schritt um ein paar Pixel. */
      if (wurzel.getBoundingClientRect().top < -8) {
        wurzel.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      zurueckKnopf();
    }

    /* Eine Frage wieder öffnen: Wahl, Reaktion und Wirkung zurücknehmen. */
    function frageZuruecksetzen(el) {
      if (el.getAttribute('data-fb-screen') !== 'frage') return;
      el.querySelectorAll('.ml-fb__kachel').forEach(function (k) { k.classList.remove('is-gewaehlt'); });
      var r = el.querySelector('[data-fb-reaktion]');
      if (r) {
        r.classList.remove('is-da');
        r.querySelectorAll('[data-fb-reaktion-bild], [data-fb-reaktion-rahmen], [data-fb-tipp-ziel], [data-fb-echo-zeile], [data-fb-echo-vorteil]').forEach(function (x) {
          x.hidden = true;
        });
      }
      var sz = el.querySelector('[data-fb-sparte-ziel]');
      if (sz) sz.hidden = true;
      var wb = el.querySelector('[data-fb-weiter]');
      if (wb) wb.disabled = true;
      var alt = el.__angewandt;
      if (alt) {
        Object.keys(alt.verschiebung).forEach(function (a) {
          profil[a] = Math.max(0, Math.min(100, (profil[a] || 50) - alt.verschiebung[a]));
        });
        alt.sperren.forEach(function (t) {
          var i = gesperrt.indexOf(t);
          if (i > -1) gesperrt.splice(i, 1);
        });
        if (alt.merkKey) delete merkmale[alt.merkKey];
        el.__angewandt = null;
      }
    }

    function zurueck() {
      if (!verlauf.length) return;
      var ziel = verlauf.pop();
      frageZuruecksetzen(ziel);
      if (typeof ziel.__schritt === 'number') schritt = ziel.__schritt;
      zeigen(ziel, true);
    }

    /* Der Zähler zählt nur Fragen, keine Fakten. */
    function zaehlerSetzen() {
      var z = wurzel.querySelector('[data-fb-zaehler]');
      if (!z) return;
      /* Progress als Lichtlinie: der Füllstand wächst, das Licht wandert darin. */
      var fragen = [];
      for (var i = 0; i < lauf.length; i++) {
        var lt = lauf[i].getAttribute('data-fb-screen');
        if (lt === 'frage' || lt === 'mehrfach') fragen.push(i);
      }
      if (!z.hasChildNodes()) z.appendChild(document.createElement('i'));
      var beantwortet = 0;
      var aktiverIndex = -1;
      fragen.forEach(function (idx, n) {
        if (idx < schritt) beantwortet += 1;
        if (idx === schritt) aktiverIndex = n;
      });
      /* Die Anzeige beginnt sichtbar gefüllt — man soll von der ersten
         Sekunde an sehen, dass hier etwas wächst. */
      var basis = 8;
      z.firstElementChild.style.width =
        Math.round(basis + (beantwortet / Math.max(fragen.length, 1)) * (100 - basis)) + '%';
      z.setAttribute('aria-label', TEXT.frage + Math.min(beantwortet + 1, fragen.length) + TEXT.von + fragen.length);
    }

    function weiter() {
      schritt += 1;
      if (schritt < lauf.length) {
        zeigen(lauf[schritt]);
      } else {
        zeigen(benannt.gate);
      }
      zaehlerSetzen();
    }

    /* Nearest Neighbor über vier Achsen; gesperrte Tags fliegen raus. */
    function auswerten() {
      var erlaubt = katalog.filter(function (p) {
        if (p.verfuegbar === false) return false;
        var daten = achsenDaten[p.handle];
        if (!daten) return false;
        var tags = daten.tags || [];
        return !tags.some(function (t) { return gesperrt.indexOf(t) > -1; });
      });

      if (!erlaubt.length) {
        erlaubt = katalog.filter(function (p) {
          return p.verfuegbar !== false && achsenDaten[p.handle];
        });
      }
      if (!erlaubt.length) return null;

      var bewertet = erlaubt.map(function (p) {
        var d = achsenDaten[p.handle];
        var summe = 0;
        ACHSEN.forEach(function (a) {
          var diff = (profil[a] || 50) - (typeof d[a] === 'number' ? d[a] : 50);
          summe += diff * diff;
        });
        return { produkt: p, daten: d, abstand: Math.sqrt(summe) };
      });

      bewertet.sort(function (x, y) { return x.abstand - y.abstand; });
      return bewertet[0];
    }

    /* Begründung aus den Achsen, auf denen der Treffer klar steht. */
    function begruendung(treffer) {
      var d = treffer.daten;
      var worte = {
        waerme:  [TEXT.frische, TEXT.waerme],
        suesse:  [TEXT.keine_suesse, TEXT.suesse],
        gewicht: [TEXT.zurueckhaltung, TEXT.praesenz],
        dunkel:  [TEXT.hell, TEXT.dunkel]
      };
      var wuensche = [];
      ACHSEN.forEach(function (a) {
        var wert = typeof d[a] === 'number' ? d[a] : 50;
        if (Math.abs(wert - 50) >= 15) wuensche.push(worte[a][wert >= 50 ? 1 : 0]);
      });
      if (!wuensche.length) return '';
      wuensche = wuensche.slice(0, 3);
      var satz = wuensche.length === 1
        ? wuensche[0]
        : wuensche.slice(0, -1).join(', ') + TEXT.und + wuensche[wuensche.length - 1];
      return TEXT.du_wolltest + satz + '.';
    }

    /* --- Kachel-Klicks: Wahl zeigen, Reaktion in die Mitte, Weiter frei. --- */
    wurzel.querySelectorAll('[data-fb-wahl]').forEach(function (kachel) {
      kachel.addEventListener('click', function () {
        var screen = kachel.closest('[data-fb-screen]');

        /* Umwählen ist erlaubt: die alte Wirkung wird zurückgenommen. */
        var alt = screen.__angewandt;
        if (alt) {
          Object.keys(alt.verschiebung).forEach(function (a) {
            profil[a] = Math.max(0, Math.min(100, (profil[a] || 50) - alt.verschiebung[a]));
          });
          alt.sperren.forEach(function (t) {
            var i = gesperrt.indexOf(t);
            if (i > -1) gesperrt.splice(i, 1);
          });
          if (alt.merkKey) delete merkmale[alt.merkKey];
          screen.__angewandt = null;
        }
        screen.querySelectorAll('.ml-fb__kachel').forEach(function (k) {
          k.classList.remove('is-gewaehlt');
        });

        var verschiebung = achsenLesen(kachel.getAttribute('data-fb-achsen'));
        Object.keys(verschiebung).forEach(function (a) {
          profil[a] = Math.max(0, Math.min(100, (profil[a] || 50) + verschiebung[a]));
        });

        var merkKey = '';
        var merken = (kachel.getAttribute('data-fb-merken') || '').trim();
        if (merken && merken.indexOf('=') > -1) {
          var mk = merken.split('=');
          merkKey = mk[0].trim();
          merkmale[merkKey] = mk[1].trim();
        }

        var sperren = [];
        var sperre = (kachel.getAttribute('data-fb-sperre') || '').trim();
        if (sperre) {
          sperre.split(',').forEach(function (t) {
            t = t.trim();
            if (t) { gesperrt.push(t); sperren.push(t); }
          });
        }
        screen.__angewandt = { verschiebung: verschiebung, sperren: sperren, merkKey: merkKey };

        kachel.classList.add('is-gewaehlt');
        melden('wahl', screenName(screen), lauf.indexOf(screen) + 1, kachel.getAttribute('data-fb-kachelname') || '');

        var story = (kachel.getAttribute('data-fb-story') || '').trim();
        var titel = (kachel.querySelector('.ml-fb__kachel-titel') || {}).textContent || '';

        /* Mit Story: die Info bekommt ihre eigene Seite — Bild, Text,
           Herkunftskarte. Ohne: Echo + "Warum wir" in der Mitte. */
        if (story && benannt.stoff) {
          var st = benannt.stoff;
          var bEl = st.querySelector('[data-fb-stoff-bild]');
          if (bEl) {
            /* Das Bild der gewaehlten Kachel wandert mit auf die Stoff-Seite.
               Der Name des Stoffes wandert mit, damit das Stylesheet den
               Ausschnitt dort eigens setzen kann: die Flaeche ist deutlich
               breiter als die Kachel, dieselbe Stelle sitzt darin anders.
               Ohne Bild bleibt der Verlauf aus dem Stylesheet stehen. */
            var bild = (kachel.getAttribute('data-fb-bild') || '').trim();
            var kname = (kachel.getAttribute('data-fb-kachelname') || '').trim();
            bEl.style.backgroundImage = bild ? 'url("' + bild.replace(/"/g, '%22') + '")' : '';
            bEl.style.backgroundPosition = '';
            if (kname) { bEl.setAttribute('data-fb-kachelname', kname); }
            else { bEl.removeAttribute('data-fb-kachelname'); }
            bEl.hidden = false;
          }
          st.querySelector('[data-fb-stoff-name]').textContent = titel;
          st.querySelector('[data-fb-stoff-text]').textContent = story;
          setTimeout(function () { zeigen(benannt.stoff); }, 350);
          return;
        }

        /* Ohne jede Erklärung (kein Stoff, keine Sparte, kein Echo):
           die Wahl steht — weiter, ohne dass man drücken muss. */
        var sparte = (kachel.getAttribute('data-fb-sparte') || '').trim();
        var echoWert = (kachel.getAttribute('data-fb-echo') || '').trim();
        var vorteilWert = (kachel.getAttribute('data-fb-vorteil') || '').trim();
        if (!sparte && !echoWert && !vorteilWert && screen.getAttribute('data-fb-tipp') !== 'true') {
          var wbA = screen.querySelector('[data-fb-weiter]');
          if (wbA) wbA.disabled = false;
          setTimeout(weiter, 380);
          return;
        }

        var spZiel = screen.querySelector('[data-fb-sparte-ziel]');
        if (sparte && spZiel) {
          spZiel.hidden = false;
          spZiel.querySelector('[data-fb-sparte-name]').textContent = sparte.toUpperCase();
          spZiel.querySelector('[data-fb-sparte-erklaerung]').textContent =
            (kachel.getAttribute('data-fb-echo') || '').trim();
          var spIcon = kachel.querySelector('.ml-fb__sparte-zeile svg');
          /* Antworten ohne eigenes Sparten-Icon (Die Marinelie-DNA) bekommen
             unseren Stein; vorher blieb der Platz leer. */
          var steinVorlage = wurzel.querySelector('template[data-fb-stein]');
          spZiel.querySelector('[data-fb-sparte-icon]').innerHTML = spIcon
            ? spIcon.outerHTML
            : (steinVorlage ? steinVorlage.innerHTML : '');
          var wbS = screen.querySelector('[data-fb-weiter]');
          if (wbS) wbS.disabled = false;
          return;
        }

        var r = screen.querySelector('[data-fb-reaktion]');
        if (r) {
          var echo = (kachel.getAttribute('data-fb-echo') || '').trim();
          var vorteil = (kachel.getAttribute('data-fb-vorteil') || '').trim();

          /* Digitale Laufschrift: der Callout tippt sich selbst. */
          if (screen.getAttribute('data-fb-tipp') === 'true') {
            var tz = r.querySelector('[data-fb-tipp-ziel]');
            if (tz) {
              var voll = vorteil || echo;
              var ttxt = tz.querySelector('[data-fb-tipp-text]');
              tz.hidden = false;
              if (screen.__tippTimer) clearInterval(screen.__tippTimer);
              var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              if (reduce) {
                ttxt.textContent = voll;
              } else {
                ttxt.textContent = '';
                var pos = 0;
                screen.__tippTimer = setInterval(function () {
                  pos += 1;
                  ttxt.textContent = voll.slice(0, pos);
                  if (pos >= voll.length) clearInterval(screen.__tippTimer);
                }, 16);
              }
            }
            var wbT = screen.querySelector('[data-fb-weiter]');
            if (wbT) wbT.disabled = false;
            return;
          }
          var eEl = r.querySelector('[data-fb-echo-zeile]');
          var vEl = r.querySelector('[data-fb-echo-vorteil]');
          if (eEl) {
            eEl.hidden = !echo;
            eEl.querySelector('[data-fb-echo-text]').textContent = echo;
          }
          if (vEl) {
            vEl.hidden = !vorteil;
            if (vorteil) vEl.querySelector('[data-fb-vorteil-text]').textContent = vorteil;
          }
          r.classList.add('is-da');
        }

        var wb = screen.querySelector('[data-fb-weiter]');
        if (wb) wb.disabled = false;
      });
    });

    /* Mehrfachwahl: Chips togglen, Bestätigen wendet alle an. */
    wurzel.querySelectorAll('[data-fb-screen="mehrfach"]').forEach(function (screen) {
      screen.querySelectorAll('[data-fb-chip]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          chip.classList.toggle('is-gewaehlt');
        });
      });
      var ok = screen.querySelector('[data-fb-bestaetigen]');
      if (ok) {
        ok.addEventListener('click', function () {
          screen.querySelectorAll('[data-fb-chip].is-gewaehlt').forEach(function (chip) {
            var v = achsenLesen(chip.getAttribute('data-fb-achsen'));
            Object.keys(v).forEach(function (a) {
              profil[a] = Math.max(0, Math.min(100, (profil[a] || 50) + v[a]));
            });
          });
          weiter();
        });
      }
    });

    /* Geschlecht: eine Wahl, kein Zwang. */
    wurzel.querySelectorAll('[data-fb-geschlecht]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        wurzel.querySelectorAll('[data-fb-geschlecht]').forEach(function (c) {
          c.classList.remove('is-gewaehlt');
        });
        chip.classList.add('is-gewaehlt');
        merkmale.geschlecht = chip.getAttribute('data-fb-geschlecht');
      });
    });

    wurzel.querySelectorAll('[data-fb-quelle]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        wurzel.querySelectorAll('[data-fb-quelle]').forEach(function (c) {
          c.classList.remove('is-gewaehlt');
        });
        chip.classList.add('is-gewaehlt');
        merkmale.quelle = chip.getAttribute('data-fb-quelle');
      });
    });

    /* Der Regler: wie viele Düfte, in etwa. 30 heißt: mehr als genug. */
    var regler = wurzel.querySelector('[data-fb-sammlung]');
    if (regler) {
      var reglerWert = wurzel.querySelector('[data-fb-sammlung-wert]');
      regler.addEventListener('input', function () {
        var n = parseInt(regler.value, 10) || 0;
        if (reglerWert) reglerWert.textContent = n >= 30 ? '30+' : String(n);
        merkmale.sammlung = n >= 30 ? '30+' : String(n);
      });
    }

    /* Bestaetigungstext und data-platz auf die echte Zahl ziehen; der
       Text kommt aus Liquid mit der Zahl im deutschen Format. */
    function platzSetzen(neu) {
      var bEl = wurzel.querySelector('[data-fb-bestaetigung]');
      if (!bEl || !(neu > 0)) return;
      var alt = parseInt(bEl.getAttribute('data-platz'), 10) || 0;
      if (alt > 0 && alt !== neu) {
        bEl.textContent = bEl.textContent.split(alt.toLocaleString('de-DE')).join(neu.toLocaleString('de-DE'));
      }
      bEl.setAttribute('data-platz', String(neu));
    }

    /* Die Karte lebt: die nächste freie Nummer rückt weiter, während man
       zusieht — im Knopf gleich mit. */
    (function () {
      var liste = wurzel.querySelector('[data-fb-liste]');
      if (!liste) return;
      var frei = parseInt(liste.getAttribute('data-start'), 10) || 0;
      var freiEl = liste.querySelector('[data-fb-liste-frei]');
      var knopfEl = liste.querySelector('[data-fb-liste-knopf]');
      var fmt = function (n) { return n > 0 ? n.toLocaleString('de-DE') : '—'; };

      function malen() {
        if (freiEl) freiEl.textContent = fmt(frei);
        if (knopfEl) knopfEl.textContent = fmt(frei);
      }
      malen();

      /* Der Platz kommt vom Server: genau der, den der naechste Gast
         bekommt (1000 + 2,5 je Gast, LOG 17.10.). Das Metafeld zaehlte
         nur Gaeste + 1 und wurde nirgends vergeben (Otton 21.10.: "A").
         Antwortet der Server nicht, bleibt die Zahl aus dem Theme. */
      fetch(endpunkt + '/naechster', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !(d.platz > 0)) return;
          frei = d.platz;
          malen();
          platzSetzen(d.platz);
        })
        .catch(function () {});

      /* Der Zaehler lief alle 4,2 Sekunden weiter — das sieht kein Mensch
         als echte Eintragung, sondern als Zaehlwerk. Jetzt geht er im
         Takt, den die Einstellungen vorgeben, und nie zweimal im selben
         Abstand: irgendwo zwischen kuerzestem und laengstem Wert. */
      var taktMin = (parseFloat(wurzel.getAttribute('data-takt-min')) || 3) * 60000;
      /* 0 heisst aus: der Platz kommt jetzt aus der Liste selbst und
         rueckt nicht mehr im Browser vor (Otton, 17.10.2026). Vorher
         machte "|| 12" aus der 0 wieder zwoelf Minuten. */
      var taktRoh = parseFloat(wurzel.getAttribute('data-takt-max'));
      var taktMax = (isNaN(taktRoh) ? 12 : taktRoh) * 60000;
      if (taktMax === 0 || frei === 0) return;
      if (taktMax < taktMin) taktMax = taktMin;

      function nachruecken() {
        var screen = liste.closest('[data-fb-screen]');
        if (screen.classList.contains('is-aktiv')) {
          frei += 1;
          if (freiEl) {
            freiEl.classList.remove('is-tick');
            void freiEl.offsetWidth;
            freiEl.classList.add('is-tick');
          }
          malen();
        }
        window.setTimeout(nachruecken, taktMin + Math.random() * (taktMax - taktMin));
      }

      if (taktMax > 0) {
        window.setTimeout(nachruecken, taktMin + Math.random() * (taktMax - taktMin));
      }
    })();

    /* Fragen mit Story-Antworten springen von selbst weiter. */
    wurzel.querySelectorAll('[data-fb-screen="frage"]').forEach(function (screen) {
      var hatStory = Array.prototype.some.call(
        screen.querySelectorAll('[data-fb-wahl]'),
        function (k) { return (k.getAttribute('data-fb-story') || '').trim() !== ''; }
      );
      if (hatStory) {
        var wb = screen.querySelector('[data-fb-weiter]');
        if (wb) wb.hidden = true;
      }
    });

    var zk = wurzel.querySelector('[data-fb-zurueck]');
    if (zk) zk.addEventListener('click', zurueck);

    var start = wurzel.querySelector('[data-fb-start]');
    if (start) start.addEventListener('click', weiter);
    /* Vom Quiz-Start der Startseite (Otton 24.10.2026) kommt man mit
       ?start=1, im Fenster oder als Seite: dort stand der Auftakt schon,
       also gleich Frage 1 statt ihn ein zweites Mal zu zeigen. */
    var direkt = window.mlQuizDirekt || /[?&]start=1(&|$)/.test(location.search);
    window.mlQuizDirekt = false;
    if (start && direkt) setTimeout(function () { start.click(); }, 0);

    wurzel.querySelectorAll('[data-fb-weiter]').forEach(function (k) {
      k.addEventListener('click', weiter);
    });

    /* --- Ergebnis: Bilder, Probe, Warenkorb --- */
    var probeId = parseInt(wurzel.getAttribute('data-probe'), 10) || 0;
    var korbPfad = (window.routes && window.routes.cart_add_url) || '/cart/add';

    function ergebnisFuellen(treffer) {
      if (!treffer) return;
      var p = treffer.produkt;
      var kt = wurzel.querySelector('[data-fb-match-titel]');
      var kg = wurzel.querySelector('[data-fb-match-grund]');
      var kl = wurzel.querySelector('[data-fb-match-link]');
      if (kt) kt.textContent = p.titel;
      if (kg) kg.textContent = begruendung(treffer);
      if (kl) kl.setAttribute('href', p.url);

      /* Produktbild und Shop-All-Bild nebeneinander (Otton 21.10.). Fehlt
         eines, bleibt das Feld lieber leer als halb. */
      var bilder = wurzel.querySelector('[data-fb-match-bilder]');
      if (bilder) {
        bilder.innerHTML = '';
        if (p.bild && p.bild2) {
          [[p.bild, p.titel], [p.bild2, p.titel]].forEach(function (b) {
            var img = document.createElement('img');
            img.src = b[0];
            img.alt = b[1];
            img.loading = 'eager';
            bilder.appendChild(img);
          });
          bilder.hidden = false;
        } else {
          bilder.hidden = true;
        }
      }

      var knopf = wurzel.querySelector('[data-fb-korb]');
      if (knopf) {
        if (p.variante && p.variante_verfuegbar !== false) {
          knopf.setAttribute('data-variante', String(p.variante));
          knopf.textContent = (knopf.getAttribute('data-text') || '') + (p.variante_preis ? ' · ' + p.variante_preis : '');
          knopf.hidden = false;
        } else {
          knopf.hidden = true;
        }
      }
    }

    /* Die Probe liegt nach dem Eintragen einmal im Korb, wie im
       Tester-Funnel (Otton 21.10.). Ohne die Marke _gratis_tester: die
       macht sie im Schubfach zur unsichtbaren Beigabe, und ein Korb mit
       nur der Probe galt dann als leer. Die Probe darf aber allein bestellt
       werden (Otton: "lassen wir erstmal so"). Mehr als eine haelt
       ml-korb.js (gratisDeckeln) ohnehin auf. Der Kasten erscheint erst,
       wenn sie wirklich drin ist. */
    function probeHinein() {
      var kasten = wurzel.querySelector('[data-fb-probe]');
      if (!probeId || !kasten) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (korb) {
          var zeilen = (korb && korb.items) || [];
          if (zeilen.some(function (i) { return i.variant_id === probeId; })) return true;
          /* Sie zaehlt als die eine Gratis-Probe (ml-korb-tester.liquid).
             Hat jemand schon eine gewaehlt, bleibt es bei der. */
          if (zeilen.some(function (i) { return i.properties && i.properties._gratis_tester === 'ja'; })) return false;
          return fetch(korbPfad + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: probeId, quantity: 1, properties: { _guestlist_probe: 'ja' } }] })
          }).then(function (r) { return r.ok; });
        })
        .then(function (drin) { if (drin) kasten.hidden = false; })
        .catch(function () {});
    }

    /* "In den Warenkorb": legt die Standardvariante hinein und fuehrt auf
       die Duftseite, dort oeffnet ml-korb.js das Schubfach (?warenkorb=auf).
       Otton 21.10.2026: "in den warenkorb soll den drawer zeigen auf der
       jeweiligen duftseite". Das Schubfach hier auf der Guestlist-Seite
       neu zu zeichnen lief im Test ins Leere und landete auf /cart. */
    var korbKnopf = wurzel.querySelector('[data-fb-korb]');
    if (korbKnopf) {
      korbKnopf.addEventListener('click', function () {
        var vid = parseInt(korbKnopf.getAttribute('data-variante'), 10) || 0;
        var link = wurzel.querySelector('[data-fb-match-link]');
        var ziel = link ? link.getAttribute('href') : '';
        if (!vid || !ziel || ziel === '#') { if (ziel && ziel !== '#') window.location.href = ziel; return; }
        melden('wahl', 'match', lauf.length + 3, 'korb');
        korbKnopf.disabled = true;
        var mitKorb = ziel + (ziel.indexOf('?') > -1 ? '&' : '?') + 'warenkorb=auf';
        fetch(korbPfad + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
          .then(function (r) {
            /* Ging es nicht hinein (ausverkauft), fuehrt der Knopf trotzdem
               zur Duftseite, nur ohne offenes Schubfach. */
            window.location.href = r.ok ? mitKorb : ziel;
          })
          .catch(function () { window.location.href = ziel; });
      });
    }

    /* --- Gate --- */
    /* Name und Mail stehen zusammen auf einem Schritt; der frühere
       Weiter-Knopf dazwischen ist entfallen. */

    /* Riegel: der eigene Platz steht dazu, sobald der Browser ihn kennt. */
    var zugangEl = wurzel.querySelector('[data-fb-zugang]');
    if (zugangEl) {
      var stand = lesen();
      if (stand && stand.position) {
        zugangEl.textContent += ' · Dein Platz ' + Number(stand.position).toLocaleString('de-DE');
      }
    }

    var form = wurzel.querySelector('[data-fb-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var mail = (wurzel.querySelector('[data-fb-mail]') || {}).value || '';
        var name = (wurzel.querySelector('[data-fb-name]') || {}).value || '';
        var fehler = wurzel.querySelector('[data-fb-fehler]');
        var knopf = wurzel.querySelector('[data-fb-senden]');
        /* Beide Felder tragen required, der Browser haelt hier normalerweise
           schon an. Der Riegel bleibt trotzdem stehen. */
        if (!mail.trim() || !name.trim()) return;

        /* Ohne Haken geht nichts hinaus. */
        var haken = wurzel.querySelector('[data-fb-consent]');
        if (haken && !haken.checked) {
          if (fehler) {
            fehler.hidden = false;
            fehler.textContent = TEXT.ohne_einwilligung;
          }
          return;
        }

        knopf.disabled = true;
        knopf.textContent = TEXT.moment;
        if (fehler) fehler.hidden = true;

        var treffer = auswerten();

        var werber = '';
        try {
          werber = new URLSearchParams(location.search).get('q') || '';
          if (!werber) {
            var m = document.cookie.match(/(?:^|;\s*)ml_werber=([^;]*)/);
            werber = m ? decodeURIComponent(m[1]) : '';
          }
        } catch (e) {}

        /* Weg 1: Klaviyo nimmt die Eintragung selbst entgegen. Der
           Client-Endpunkt braucht keinen geheimen Schluessel — die
           Company-ID darf oeffentlich stehen, sie kann nur eintragen.
           Liste ist seit 17.10.2026 die Email List WTbX8B (Single Opt-in,
           Guestlist = Newsletter); vorher XfPLMD mit Double Opt-in, dort
           kamen nur 6 Profile an. Eine Platznummer gibt dieser Weg nicht
           zurueck; sie kommt aus dem Klaviyo-Feld guestlist_platz. */
        var klaviyoId = wurzel.getAttribute('data-klaviyo') || '';
        var klaviyoListe = wurzel.getAttribute('data-klaviyo-liste') || '';

        if (klaviyoId && klaviyoListe) {
          /* Feldnamen quiz_ statt ml_, damit man sie in Klaviyo versteht
             (Laura 19.10.2026); gewicht heisst dort Intensitaet, match
             Empfehlung. Die 9 Profile von vorher sind schon umbenannt;
             das Cookie ml_werber und die Dateinamen bleiben. */
          var eigenschaften = {
            quiz_quelle: 'The Guestlist',
            quiz_waerme: profil.waerme,
            quiz_suesse: profil.suesse,
            quiz_intensitaet: profil.gewicht,
            quiz_dunkel: profil.dunkel,
            quiz_empfehlung: treffer ? treffer.produkt.handle : '',
            quiz_werber: werber,
            quiz_eingetragen: new Date().toISOString()
          };
          Object.keys(merkmale).forEach(function (k) {
            eigenschaften['quiz_' + k] = merkmale[k];
          });
          /* Herkunft aus der Landing-URL (Meta-Ads ab 21.10.2026): nur
             setzen, was es gibt, damit ein leerer Wert keine fruehere
             Herkunft im Profil ueberschreibt. */
          var herkunft = herkunftLesen();
          ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) {
            if (herkunft[k]) eigenschaften['quiz_' + k] = herkunft[k];
          });

          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              /* 2025-07-15, nicht 2024-10-15: die alte Revision kennt das
                 Feld `subscriptions` am Profil nicht und antwortet 400
                 ("'subscriptions' is not a valid field"). Darum kam seit
                 dem 28.08. niemand auf die Guestlist (Otton, 13.10.: "kann
                 mich nicht eintragen"). Das Popup (ml-queue.js) nutzt die
                 neue Revision und ging immer durch. */
              revision: '2025-07-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'The Guestlist',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: mail,
                        first_name: name,
                        properties: eigenschaften,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                      }
                    }
                  }
                },
                relationships: { list: { data: { type: 'list', id: klaviyoListe } } }
              }
            })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('HTTP ' + r.status);

              /* Klaviyo vergibt keinen Platz. Darum zusaetzlich beim
                 Server anmelden: der vergibt ihn nach der 2,5-Regel und
                 schreibt guestlist_platz an Klaviyo. Bis 21.10. bekam
                 niemand aus dem Quiz einen Platz (11 von 11 ohne). Der
                 Server darf das Eintragen nie aufhalten: nach 4 s geht
                 es ohne ihn weiter. */
              var ab = window.AbortController ? new AbortController() : null;
              var uhr = setTimeout(function () { if (ab) ab.abort(); }, 4000);
              return fetch(endpunkt + '/join', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: mail, quelle: 'quiz' }),
                signal: ab ? ab.signal : undefined
              })
                .then(function (j) { return j.ok ? j.json() : null; })
                .catch(function () { return null; })
                .then(function (d) {
                  clearTimeout(uhr);
                  return d && d.platz > 0 ? d.platz : 0;
                });
            })
            .then(function (platz) {
              if (platz) platzSetzen(platz);

              schreiben({
                email: mail,
                name: name,
                position: platz || 0,
                joinedAt: new Date().toISOString(),
                match: treffer ? treffer.produkt.handle : ''
              });

              /* Keine Nummer, also auch keine erfundene: die Stelle, an
                 der sie stuende, bleibt leer, dafuer steht da, was als
                 Naechstes passiert. */
              var lEl = wurzel.querySelector('[data-fb-nummer-label]');
              var nEl2 = wurzel.querySelector('[data-fb-nummer]');
              var bEl = wurzel.querySelector('[data-fb-bestaetigung]');
              /* Der Einstiegs-Platz steht gross da, die Mitgliedsnummer
                 gar nicht (Otton, 17.10.2026). Ohne Zahl bleibt es beim
                 Satz, ohne erfundene Nummer. */
              var einstieg = bEl ? parseInt(bEl.getAttribute('data-platz'), 10) || 0 : 0;
              if (einstieg > 0 && nEl2) {
                nEl2.textContent = einstieg.toLocaleString('de-DE');
              } else {
                if (lEl) lEl.textContent = TEXT.auf_der_liste;
                if (nEl2) nEl2.hidden = true;
              }
              if (bEl) bEl.hidden = false;

              ergebnisFuellen(treffer);
              melden('ende', 'gate', lauf.length + 1, treffer ? treffer.produkt.handle : '');
              probeHinein();

              zeigen(benannt.nummer);
              document.dispatchEvent(new CustomEvent('ml:guestlist:join', { detail: lesen(), bubbles: true }));
              window.dispatchEvent(new CustomEvent('ml:guestlist:join', { detail: lesen() }));
            })
            .catch(function () {
              knopf.disabled = false;
              knopf.textContent = TEXT.nochmal;
              if (fehler) {
                fehler.hidden = false;
                fehler.textContent = TEXT.fehler_eintragen;
              }
            });
          return;
        }

        /* Weg 2: die eigene Vergabe hinter dem App-Proxy — sie kennt die
           Reihenfolge und gibt die Nummer sofort zurueck. */
        fetch(endpunkt + '/join', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: mail,
            name: name,
            werber: werber,
            match: treffer ? treffer.produkt.handle : '',
            profil: profil,
            merkmale: merkmale,
            duelle: true
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (daten) {
            if (!daten || !daten.position) throw new Error('kein Platz');

            schreiben({
              email: mail,
              name: name,
              position: daten.position,
              account: daten.account || 0,
              access: daten.access || null,
              joinedAt: daten.joinedAt || new Date().toISOString(),
              match: treffer ? treffer.produkt.handle : ''
            });

            var nEl = wurzel.querySelector('[data-fb-nummer]');
            if (nEl) nEl.textContent = String(daten.position);

            var zEl = wurzel.querySelector('[data-fb-zugriff]');
            if (zEl && daten.access) {
              zEl.textContent = daten.access.text;
              zEl.hidden = false;
            }

            if (daten.bestand) {
              var t = wurzel.querySelector('[data-fb-nummer-text]');
              if (t) t.textContent = TEXT.schon_dabei;
            }

            ergebnisFuellen(treffer);
            melden('ende', 'gate', lauf.length + 1, treffer ? treffer.produkt.handle : '');
            probeHinein();

            zeigen(benannt.nummer);
            document.dispatchEvent(new CustomEvent('ml:guestlist:join', { detail: lesen(), bubbles: true }));
            window.dispatchEvent(new CustomEvent('ml:guestlist:join', { detail: lesen() }));
          })
          .catch(function () {
            knopf.disabled = false;
            knopf.textContent = TEXT.nochmal;
            if (fehler) {
              fehler.hidden = false;
              fehler.textContent = TEXT.fehler_vergabe;
            }
          });
      });
    }

    var reveal = wurzel.querySelector('[data-fb-reveal]');
    if (reveal) {
      reveal.addEventListener('click', function () {
        zeigen(benannt.match);
      });
    }

    var startScreen = wurzel.querySelector('.is-aktiv');
    if (startScreen) melden('zeige', screenName(startScreen), 0);

    zaehlerSetzen();
  }

  /* Weitergeben: ?q=<platz> als Cookie, 30 Tage. */
  (function werberMerken() {
    try {
      var q = new URLSearchParams(location.search).get('q');
      if (!q) return;
      var ablauf = new Date(Date.now() + 30 * 864e5).toUTCString();
      document.cookie = 'ml_werber=' + encodeURIComponent(q) + ';expires=' + ablauf + ';path=/;SameSite=Lax';
    } catch (e) {}
  })();

  /* Herkunft beim Landen merken (sessionStorage, nur dieser Tab): die
     Anzeige fuehrt mit ?utm_...&fbclid= auf die Guestlist-Seite, eingetragen
     wird oft erst Schritte spaeter. Ohne Parameter bleibt der alte Stand. */
  var HERKUNFT = 'ml_herkunft';
  (function herkunftMerken() {
    try {
      var p = new URLSearchParams(location.search);
      var h = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid'].forEach(function (k) {
        var v = p.get(k);
        if (v) h[k] = v.slice(0, 200);
      });
      if (Object.keys(h).length) sessionStorage.setItem(HERKUNFT, JSON.stringify(h));
    } catch (e) {}
  })();
  function herkunftLesen() {
    try { return JSON.parse(sessionStorage.getItem(HERKUNFT) || '{}') || {}; } catch (e) { return {}; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
